import {
  readable
} from 'svelte/store';

let data = [{
  id: 'buxton',
  title: "It flows - A Weird and Wonderful Wander in Buxton",
  image: "assets/photo",
  distance: "0.2",
  startLocation: "Buxton Trainstation",
  length: "30-50",
  summary: " Follow in the path of Cassie as she hops a train to Buxton in an effort to learn about Britain’s pagan past and help kickstart her life again...",
  description: '<h6>Description</h6><p><strong>Experience Buxton like never before.</strong></p><p><em>Maybe things wouldn’t feel so heavy if I could just...flow….</em></p><p>Cassie is at a crossroads. Frustrated professionally, and with her personal life in turmoil, she hops a train toBuxton in an effort to learn about Britain’s pagan past and help kickstart her life again...</p><p>...But, in the shadow of St. Anne’s Well, something strange is about to surface, something that might just change the entire course of Cassie’s life…</p><p><em>*Water was created entirely in accordance with social distancing regulations and designed so it can be experienced in the same manner.</em></p><h6>Cast</h6><p class="caption"><strong>Cassie:</strong> Karren Young</p><p class="caption"><strong>Alex:</strong> Liz Hann</p><h6>Creative</h6><p class="caption"><strong>Written By:</strong> Harry Machray</p><p class="caption"><strong>Sound By:</strong> Findlay Claydon</p><p class="caption"><strong>Music By:</strong> Tammy Howarth</p><p class="caption"><strong>Programmed by:</strong> Dylan Howells / Findlay Claydon</p>'
}]

export const stories = readable(data, function start(set) {
  // implementation goes here

  return function stop() {};
});
